/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, { Component } from 'react';
// material
import { ContentType } from '@insticator/insticator-ui'; // iui-material
// styles
import injectSheet from 'react-jss';
import styles from 'material/embeds/contentindicator/contentindicator_styles';



/* ========== ~~~~~~~~~~ EMBED : CONTENT INDICATOR  ~~~~~~~~~~ ========== */
class ContentIndicator extends Component {
	constructor(props){
		super(props);
		this.typeMap = this.props.withCount ? this.props.activeContents : null;
	}
	handleType = (type) => {
		switch (this.props.type) {
			case 'select':
				this.props.processClick(type);
				break;
			case 'sort':
				this.props.processClick(type);
				break;
			case 'key':
			default:
				// console.log(type)
				break;
		}
	};
	isActive = (type) => {
		if(this.props.type === 'sort') { return false }
		if(this.props.withCount) { return !!this.typeMap[type.toUpperCase()] }
		return this.props.activeContents !== null && this.props.activeContents.length > 0 ? this.props.activeContents.includes(type) ||  this.props.activeContents.includes(type.toUpperCase()) : false;
	};

	getCount = (type) => this.typeMap && this.typeMap[type];
	render() {
        return (
            <span className={`contentindicator ${this.props.classes.contentindicator} type-${this.props.type} greyOut-${this.props.disabled}`}>
				<ContentType type={`quiz`} handleClick={this.handleType} indicatorType={this.props.type} isLive={this.isActive('quiz')} count={this.getCount('QUIZ')} />
				<ContentType type={`poll`} handleClick={this.handleType} indicatorType={this.props.type} isLive={this.isActive('poll')} count={this.getCount('POLL')}/>
				<ContentType type={`story`} handleClick={this.handleType} indicatorType={this.props.type} isLive={this.isActive('story')} count={this.getCount('STORY')} />
        	</span>
        )
	}
}



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(ContentIndicator);
